import SimpleEditor from "react-simple-code-editor";
import { h } from "preact";

export const Editor = (props: any) => <SimpleEditor {...props} />;
